import { render, staticRenderFns } from "./PolicyInfo.vue?vue&type=template&id=14030f15&scoped=true"
import script from "./PolicyInfo.vue?vue&type=script&lang=js"
export * from "./PolicyInfo.vue?vue&type=script&lang=js"
import style0 from "./PolicyInfo.vue?vue&type=style&index=0&id=14030f15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14030f15",
  null
  
)

export default component.exports